import { render } from "./broadcast_lines_mob.svg?vue&type=template&id=7724f030"
const script = {}
script.render = render

export default script